function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import Icon from '../Icon.js';
var SvgSynchronize = function SvgSynchronize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#synchronize_svg__a)",
    stroke: "var(--icon-color)",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.43 10.216 2.216-.555.554 2.216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.42 9.718A6.672 6.672 0 0 1 8 14.646a6.672 6.672 0 0 1-6.24-4.376M3.57 5.784l-2.216.555L.8 4.123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58 6.282A6.672 6.672 0 0 1 8 1.354a6.672 6.672 0 0 1 6.24 4.376"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "synchronize_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};
var IconSynchronize = function IconSynchronize(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    icon: SvgSynchronize
  }, props));
};
export default IconSynchronize;